import "../../../../assets/presentation/components/controls/popup-menu/popup-menu-Cs29V2zP.css";
/* empty css           */
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { createPortal } from "react-dom";
//#region src/presentation/components/controls/popup-menu/popup-menu.tsx
var PopupMenu = ({ options, children, className, menuClassName, positionX = 132, positionY = 8 }) => {
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);
	const [menuPosition, setMenuPosition] = useState(null);
	useEffect(() => {
		if (!open) return;
		const handleClickOutside = (event) => {
			if (anchorRef.current && !anchorRef.current.contains(event.target)) setOpen(false);
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [open]);
	const handleButtonClick = () => {
		const rect = anchorRef.current?.getBoundingClientRect();
		if (rect) setMenuPosition({
			top: rect.bottom + window.scrollY + positionY,
			left: rect.right - positionX + window.scrollX
		});
		setOpen((prev) => !prev);
	};
	const handleOptionClick = (option) => {
		if (!option.disabled) {
			option.onClick();
			setOpen(false);
		}
	};
	return /* @__PURE__ */ jsxs("div", {
		className: classNames("popup-menu-anchor", className),
		ref: anchorRef,
		style: {
			display: "inline-block",
			position: "relative"
		},
		children: [/* @__PURE__ */ jsx("div", {
			onClick: handleButtonClick,
			className: "popup-menu-trigger",
			children
		}), open && menuPosition && createPortal(/* @__PURE__ */ jsx("div", {
			className: classNames("popup-menu", menuClassName),
			style: {
				position: "absolute",
				top: menuPosition.top,
				left: menuPosition.left,
				zIndex: 10
			},
			role: "menu",
			children: options.map((option, idx) => /* @__PURE__ */ jsxs("div", {
				className: classNames("popup-menu-item", { disabled: option.disabled }),
				onMouseDown: (e) => {
					e.stopPropagation();
					handleOptionClick(option);
				},
				tabIndex: 0,
				role: "menuitem",
				children: [option.icon && /* @__PURE__ */ jsx("span", {
					className: "popup-menu-icon",
					children: option.icon
				}), /* @__PURE__ */ jsx("span", { children: option.label })]
			}, idx))
		}), document.body)]
	});
};
//#endregion
export { PopupMenu };

//# sourceMappingURL=popup-menu2.js.map